// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"41917edf","453":"43a5fe21"}[chunkId] + ".chunk.js";
};